import { SuccessNotifications } from 'components/Notification';
import React, { FC, useEffect } from 'react';
import { translationKeys, useTranslation } from 'services/localization';
import { trackDisplaySuccessUpdatePreferencesBanner } from '../../../../services/userActionEvents';
import { ActionNotificationMessageProps } from '../../types';
import { Text, Stack } from '@atlaskit/primitives';

const SuccessUpdatePreferences: FC<ActionNotificationMessageProps> = ({ onClose }) => {
  const { translate } = useTranslation();

  useEffect(() => {
    trackDisplaySuccessUpdatePreferencesBanner();
  }, []);

  return (
    <SuccessNotifications
      title={translate(translationKeys.NOTIFICATION_UPDATE_SUCCESS_MESSAGE_TITLE)}
      onClose={onClose}
    >
      <Stack space='space.100'>
        <Text as='p'>{translate(translationKeys.NOTIFICATION_UPDATE_SUCCESS_MESSAGE_DESCRIPTION)}</Text>
      </Stack>
      <Text size='small'>{translate(translationKeys.NOTIFICATION_NOTE_MESSAGE)}</Text>
    </SuccessNotifications>
  );
};

export default SuccessUpdatePreferences;
